import cn from 'classnames';
import React, { FC } from 'react';

import styles from './Main.module.scss';

type MainProps = {
  className?: string;
  testID?: string;
  children?: React.ReactNode;
} & React.ComponentProps<'div'>;

export const Main: FC<MainProps> = (props) => {
  const { className, testID, children, ...rest } = props;

  return (
    <div
      className={cn(styles.container, className)}
      data-testid={testID}
      {...rest}
    >
      {children}
    </div>
  );
};
